export let LABELS = {
    AUDIO_TITLE: "Audio Title",
    AUDIO_SUB_CATEGORIES: "Sub Categories",
    AUTHOR: "Author",
    NARRATOR: "Narrator",
    STATUS: "Status",
    AUDIO_TYPE: "Audio Content",
    ACTION: "Action",
    TITLE: "Title",
    SUB_CATEGORY: "Sub Category",
    DESCRIPTION: "Description",
    UPLOAD_AUDIO: "Upload Audio",
    UPLOAD_THUMBNAIL: "Upload Thumbnail",
    UPLOAD_IMAGE: "Upload Image",

    SESSION_SUCCESS_MESSAGE: "Session Success Message",
    RADIO_GROUP: "Audio Content",
    SERIES_TITLE: "Series Title",
    SESSIONS: "Sessions",
    SESSION_TITLE: "Session Title",
    SESSION_DESCRIPTION: "Session Description",
    SESSION_SUBSCRIPTION: "Audio Content ",
    SESSION_UPLOAD_AUDIO: "Upload Audio",
    SESSION_COMPLETION_MESSAGE: "Session Success Message",
    SESSION: "Session"
};

export let NAMES = {
    [LABELS.TITLE]: "title",
    [LABELS.SUB_CATEGORY]: "subCategory",
    [LABELS.DESCRIPTION]: "description",
    [LABELS.AUTHOR]: "author",
    [LABELS.NARRATOR]: "narrator",
    [LABELS.UPLOAD_AUDIO]: "uploadAudio",
    [LABELS.UPLOAD_THUMBNAIL]: "uploadThumbnail",
    [LABELS.UPLOAD_IMAGE]: "uploadImage",

    [LABELS.SESSION_SUCCESS_MESSAGE]: "sessionSuccessMessage",
    [LABELS.RADIO_GROUP]: "radioGroup",
    [LABELS.SERIES_TITLE]: "seriesTitle",
    [LABELS.SESSIONS]: "sessions",
    [LABELS.SESSION_TITLE]: "sessionTitle",
    [LABELS.SESSION_DESCRIPTION]: "sessionDescription",
    [LABELS.SESSION_SUBSCRIPTION]: "sessionSubscription",
    [LABELS.SESSION_UPLOAD_AUDIO]: "sessionUploadAudio",
    [LABELS.SESSION_COMPLETION_MESSAGE]: "sessionCompletionmessage"
};

export let PLACEHOLDERS = {
    [LABELS.TITLE]: "Enter the title here",
    [LABELS.SUB_CATEGORY]: "Select the sub-category (e.g., Walking)",
    [LABELS.DESCRIPTION]: "Enter a brief description",
    [LABELS.AUTHOR]: "Select the author's name",
    [LABELS.NARRATOR]: "Select the narrator's name",
    [LABELS.UPLOAD_AUDIO]: "Upload an audio file",
    [LABELS.UPLOAD_THUMBNAIL]: "Upload a thumbnail image",
    [LABELS.UPLOAD_IMAGE]: "Upload a image",

    [LABELS.SESSION_SUCCESS_MESSAGE]: "Enter a success message for the session",
    [LABELS.RADIO_GROUP]: "Select audio content type",
    [LABELS.SESSION_TITLE]: "Enter the session title",
    [LABELS.SESSION_DESCRIPTION]: "Enter the session description",
    [LABELS.SESSION_COMPLETION_MESSAGE]: "Enter a success message for the session"
};

export const STATUS_OPTIONS = [
    {
        label: "Active",
        value: "Active"
    },
    {
        label: "Inactive",
        value: "Inactive"
    }
];

export const subsCriptionfilterOptions = [
    {
        label: "Premium",
        value: "Premium"
    },
    {
        label: "Freemium",
        value: "Freemium"
    }
];
